// extracted by mini-css-extract-plugin
export default {"left":"_1HiIN","center":"h1wHp","right":"tQap3","onImage":"_29pVT","offImage":"WcRfy"};